import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Changelog from '../Changelog'

class AppFooter extends Component {
  render() {
    return (
      <footer className={this.props.classes.footer} data-element="footer">
        <Changelog />
      </footer>
    )
  }
}

AppFooter.propTypes = {
  classes: PropTypes.shape({
    footer: PropTypes.string,
  }),
}

export default AppFooter
